export interface EnergyValues {
  'Energy': number;
  'Fatty acids, total saturated': number;
  'Fatty acids, total trans-polyenoic': number;
  '18:2 CLAs': number;
  'n-3': number;
  'n_6': number;
  'Fatty acids, total trans-monounsaturated': number;
        'Fiber, total dietary': number;
        'Starch': number;
      'Sucrose': number;
      'Fructose': number;
      'Galactose': number;
      'Glucose (dextrose)': number;
      'Lactose': number;
      'Maltose': number;
    'Alcohol, ethyl': number;
    'Protein': number;
    'Total lipid (fat)': number;
      'Carbohydrate, by difference': number;
    'Sugars, total': number;
    'Fatty acids, total monounsaturated': number;
    'Fatty acids, total polyunsaturated': number;
}

export interface AlgoliaSearchHighlight {
  _highlightResult: { longDesc: { value: string } };
}

export interface FoodNames {
  longDesc: string;
  objectID: string;
  comname: string;
  manufacname: string;
  foodGroup: string;
}

export type Weight = {
  amount: number
  grams: number
  desc: string
};

type Nutrients = {
  weights: Weight[]
};

export type Food = FoodNames & EnergyValues & AlgoliaSearchHighlight;
export type FoodWithNutrients = Food & Nutrients;

export const GRAMS_GIVEN = 100;

export const DAILY_CALORIES = 2000;

const driJson: Array<[string, number, string]> = [
    ['Vitamin A, RAE', 1200.0, 'ug'],
    ['Vitamin C', 120.0, 'mg'],
    ['Vitamin D', 800.0, 'IU'],
    ['Vitamin E', 19.0, 'mg'],
    ['Vitamin K', 120.0, 'mg'],
    ['Thiamin', 1.4, 'mg'],
    ['Riboflavin', 1.4, 'mg'],
    ['Niacin', 18.0, 'mg'],
    ['Vitamin B-6', 2.0, 'mg'],
    ['Pantothenic acid', 7.0, 'mg'],
    ['Choline', 550.0, 'mg'],
    ['Calcium, Ca', 1300.0, 'mg'],
    ['Copper, Cu', 1.3, 'mg'],
    ['Iron, Fe', 27.0, 'mg'],
    ['Magnesium, Mg', 420.0, 'mg'],
    ['Manganese, Mn', 2.6, 'mg'],
    ['Phosphorus, P', 1250.0, 'mg'],
    ['Selenium, Se', 70.0, 'ug'],
    ['Zinc, Zn', 13.0, 'mg'],
    ['Potassium, K', 5100.0, 'mg'],
    ['Sodium, Na', 200.0, 'mg'],
    ['Folate, DFE', 400.0, 'ug'],
    ['Vitamin B-12', 2.4, 'ug']
];

export const DRI_JSON: { [name: string]: [number, string] } = {};
for (let [name, value, unit] of driJson) {
    DRI_JSON[name] = [value, unit];
}

export const MINERALS = [
    'Calcium, Ca',
    'Copper, Cu',
    'Iron, Fe',
    'Magnesium, Mg',
    'Manganese, Mn',
    'Phosphorus, P',
    'Potassium, K',
    'Selenium, Se',
    'Sodium, Na',
    'Zinc, Zn',
  ];

export const ABREV: { [name: string]: string } = {
    'Vitamin A, RAE' : 'A',
    'Thiamin' : 'B-1',
    'Riboflavin' : 'B-2',
    'Niacin' : 'B-3',
    'Pantothenic acid': 'B-5',
    'Vitamin B-6' : 'B-6',
    'Folate, DFE': 'B-9',
    'Vitamin B-12' : 'B-12',
    'Vitamin C' : 'C',
    'Vitamin E' : 'E',
    'Vitamin K' : 'K',
    'Choline' : 'Cho',
    'Vitamin D' : 'D',
  };

for (let m of MINERALS) {
  ABREV[m] = m.split(',')[1];
}

export const VITAMINS = [
    'Vitamin A, RAE',
    'Thiamin',
    'Riboflavin',
    'Niacin',
    'Pantothenic acid',
    'Vitamin B-6',
    'Folate, DFE',
    'Vitamin B-12',
    'Choline',
    'Vitamin C',
    'Vitamin D',
    'Vitamin E',
    'Vitamin K',
  ];



// WEBPACK FOOTER //
// ./src/domain/Food.ts